import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Table as BsTable, Form } from "react-bootstrap";
import LoadingSpinner from "../../../Components/Loading/LoadingSpinner";
import Pagination from "../../../Components/Pagination/Pagination";
import { fetchMarketOrders } from "../../../store/actions/MarketSlice";

const ORDER_STATUSES = [
  { value: "", label: "All" },
  { value: "pending", label: "Pending" },
  { value: "ready_to_ship", label: "Ready to Ship" },
  { value: "shipped", label: "Shipped" },
  { value: "delivered", label: "Delivered" },
  { value: "declined", label: "Declined" },
  { value: "return_to_seller", label: "Return to Seller" },
  { value: "cancelled", label: "Cancelled" },
];

const STATUS_COLORS = {
  pending: "#f5a623",
  ready_to_ship: "#7575ff",
  shipped: "#4e14a5",
  delivered: "#01b574",
  declined: "#ff1733",
  return_to_seller: "#e31a1a",
  cancelled: "#a0aec0",
};

function StatusBadge({ status }) {
  const color = STATUS_COLORS[status] || "#a0aec0";
  return (
    <span
      className="text-uppercase fw-bold"
      style={{
        color,
        border: `1px solid ${color}`,
        borderRadius: "12px",
        padding: "2px 10px",
        fontSize: "0.75rem",
      }}
    >
      {status?.replaceAll("_", " ")}
    </span>
  );
}

export default function OrdersList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orders, ordersMeta, loading } = useSelector((state) => state.market);
  const [status, setStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(fetchMarketOrders({ status, page: currentPage, limit: 10 }));
  }, [dispatch, status, currentPage]);

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div>
      <div
        className="mb-4"
        data-aos="fade-up"
        data-aos-duration="600"
        style={{ maxWidth: "260px" }}
      >
        <Form.Select
          value={status}
          onChange={handleStatusChange}
          style={{
            backgroundColor: "#2d2d2d",
            color: "#ecf0f1",
            border: "1px solid #495057",
          }}
        >
          {ORDER_STATUSES.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Form.Select>
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="text-white" style={{ overflowX: "auto" }}>
            <BsTable variant="dark" borderless responsive className="align-middle">
              <thead>
                <tr className="text-grey">
                  <th>Order ID</th>
                  <th>Store</th>
                  <th>Buyer</th>
                  <th>Status</th>
                  <th>Total</th>
                  <th>Items</th>
                  <th>Created</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {orders?.length > 0 ? (
                  orders.map((order) => (
                    <tr
                      key={order.id}
                      style={{ borderBottom: "#56577A 1px solid" }}
                    >
                      <td>#{order.id}</td>
                      <td>{order?.store?.name || "—"}</td>
                      <td>{order?.buyer?.name || "—"}</td>
                      <td>
                        <StatusBadge status={order?.status} />
                      </td>
                      <td>
                        {order?.total_amount} {order?.currency}
                      </td>
                      <td>{order?.items_count ?? 0}</td>
                      <td>
                        {order?.created_at
                          ? new Date(order.created_at * 1000).toLocaleDateString()
                          : "—"}
                      </td>
                      <td>
                        <Button
                          onClick={() =>
                            navigate(`/dashboard/market/orders/${order.id}`)
                          }
                          className="border-0 text-uppercase text-white rounded bg-custom-gray"
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8}>
                      <h5 className="my-5 text-center text-grey">NO DATA YET</h5>
                    </td>
                  </tr>
                )}
              </tbody>
            </BsTable>
          </div>
          <Pagination
            meta={ordersMeta}
            onPageChange={handlePageChange}
            loading={loading}
            className="mt-4"
          />
        </>
      )}
    </div>
  );
}
